/*
  Replaces slider arrow buttons with a thin progress line that follows the swipe position.
  The line lives inside .slider-buttons, so it shows and hides with Dawn's own slider breakpoints.
*/
(function () {
  var updaters = new Map();
  // One observer for every track: covers window resizes and sliders that start hidden.
  var resizer =
    'ResizeObserver' in window
      ? new ResizeObserver(function (entries) {
          entries.forEach(function (entry) {
            var update = updaters.get(entry.target);
            if (update) update();
          });
        })
      : null;

  function attach(slider) {
    if (slider.dataset.progress) return;
    var track = slider.querySelector('.slider');
    var controls = slider.querySelector('.slider-buttons');
    if (!track || !controls) return;
    slider.dataset.progress = 'true';

    var line = document.createElement('div');
    line.className = 'slider-progress';
    line.setAttribute('aria-hidden', 'true');
    line.innerHTML = '<span></span>';
    controls.appendChild(line);
    var fill = line.firstChild;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      line.hidden = max <= 1;
      if (max <= 1) return;
      var share = track.clientWidth / track.scrollWidth;
      var position = Math.min(track.scrollLeft / max, 1);
      fill.style.width = share * 100 + '%';
      fill.style.transform = 'translateX(' + position * (1 / share - 1) * 100 + '%)';
    }

    track.addEventListener('scroll', update, { passive: true });
    updaters.set(track, update);
    if (resizer) resizer.observe(track);
    update();
  }

  function detach(root) {
    updaters.forEach(function (update, track) {
      if (root.contains(track)) {
        if (resizer) resizer.unobserve(track);
        updaters.delete(track);
      }
    });
  }

  function init() {
    document.querySelectorAll('slider-component').forEach(attach);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    detach(event.target);
  });
})();
